module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/kinesisvideo-2017-09-30.paginators.json
// module id = 432
// module chunks = 1